import SvgIcon, { type SvgIconProps } from "@mui/material/SvgIcon";

const stroke = {
  fill: "none",
  stroke: "currentColor",
  strokeLinecap: "round" as const,
  strokeLinejoin: "round" as const,
};

/** Filters button — horizontal filter glyph from the concept. */
export const InsightFilterIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M7 14.5V10H8.5V11.5H14.5V13H8.5V14.5H7ZM1 13V11.5H5.5V13H1ZM4 10V8.5H1V7H4V5.5H5.5V10H4ZM7 8.5V7H14.5V8.5H7ZM10 5.5V1H11.5V2.5H14.5V4H11.5V5.5H10ZM1 4V2.5H8.5V4H1Z"
      fill="#295EF1"
    />
  </SvgIcon>
);

/** Design-system ChevronDown. Rotate 180deg while the panel is open. */
export const ChevronDownIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path
      d="M11.9996 17.1C11.7746 17.1 11.5871 17.025 11.3996 16.875L2.77461 8.39995C2.43711 8.06245 2.43711 7.53745 2.77461 7.19995C3.11211 6.86245 3.63711 6.86245 3.97461 7.19995L11.9996 15.0375L20.0246 7.12495C20.3621 6.78745 20.8871 6.78745 21.2246 7.12495C21.5621 7.46245 21.5621 7.98745 21.2246 8.32495L12.5996 16.8C12.4121 16.9875 12.2246 17.1 11.9996 17.1Z"
      fill="currentColor"
    />
  </SvgIcon>
);

export const InsightSearchIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M7.33333 12.6667C10.2789 12.6667 12.6667 10.2789 12.6667 7.33333C12.6667 4.38781 10.2789 2 7.33333 2C4.38781 2 2 4.38781 2 7.33333C2 10.2789 4.38781 12.6667 7.33333 12.6667Z"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M14 14L11.1333 11.1333"
      {...stroke}
      strokeWidth="1.33333"
    />
  </SvgIcon>
);

/** Saved-filter dropdown arrow. */
export const SelectChevronIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 8 5">
    <path d="M8 0H1.176H0L4 4L8 0Z" fill="currentColor" />
  </SvgIcon>
);

/** Right-pointing dimension chevron. */
export const DimensionChevronIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <path
      d="M4.5 2.5L8 6L4.5 9.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

/** Floppy with pencil — Save changes. */
export const SaveChangesIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M8 14H3.33333C2.59695 14 2 13.403 2 12.6667V3.33333C2 2.59695 2.59695 2 3.33333 2H10.1333C10.485 2.005 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V7.33333"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M4.66675 14V9.33317C4.66675 8.96498 4.96522 8.6665 5.33341 8.6665H8.66675"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M4.66675 2V4.66667C4.66675 5.03486 4.96522 5.33333 5.33341 5.33333H10.0001"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M13.1953 9.13807C13.4557 8.87772 13.8778 8.87772 14.1381 9.13807L14.5286 9.52859C14.789 9.78894 14.789 10.2111 14.5286 10.4714L11.3333 13.6667L9.66667 14.3333L10.3333 12.6667L13.1953 9.13807Z"
      {...stroke}
      strokeWidth="1.33333"
    />
  </SvgIcon>
);

/** Floppy — Save as new. */
export const SaveNewIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M10.1333 2C10.485 2.00501 10.8205 2.14878 11.0667 2.4L13.6 4.93333C13.8512 5.17951 13.995 5.51497 14 5.86667V12.6667C14 13.0203 13.8595 13.3594 13.6095 13.6095C13.3594 13.8595 13.0203 14 12.6667 14H3.33333C2.97971 14 2.64057 13.8595 2.39052 13.6095C2.14048 13.3594 2 13.0203 2 12.6667V3.33333C2 2.97971 2.14048 2.64057 2.39052 2.39052C2.64057 2.14048 2.97971 2 3.33333 2H10.1333Z"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M11.3334 13.9998V9.33317C11.3334 9.15636 11.2632 8.98679 11.1382 8.86177C11.0131 8.73674 10.8436 8.6665 10.6667 8.6665H5.33341C5.1566 8.6665 4.98703 8.73674 4.86201 8.86177C4.73699 8.98679 4.66675 9.15636 4.66675 9.33317V13.9998"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M4.66675 2V4.66667C4.66675 4.84348 4.73699 5.01305 4.86201 5.13807C4.98703 5.2631 5.1566 5.33333 5.33341 5.33333H10.0001"
      {...stroke}
      strokeWidth="1.33333"
    />
  </SvgIcon>
);

export const InsightSettingsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M8.14667 1.3335H7.85333C7.49971 1.3335 7.16057 1.47397 6.91053 1.72402C6.66048 1.97407 6.52 2.31321 6.52 2.66683V2.78683C6.51976 3.02065 6.45804 3.25029 6.34103 3.45272C6.22401 3.65515 6.05583 3.82325 5.85333 3.94016L5.56667 4.10683C5.36398 4.22385 5.13405 4.28546 4.9 4.28546C4.66595 4.28546 4.43603 4.22385 4.23333 4.10683L4.13333 4.0535C3.82738 3.877 3.46389 3.82913 3.12267 3.92037C2.78145 4.01161 2.49037 4.23452 2.31333 4.54016L2.16667 4.7935C1.99018 5.09945 1.9423 5.46294 2.03354 5.80416C2.12478 6.14539 2.34769 6.43646 2.65333 6.6135L2.75333 6.68016C2.95485 6.7965 3.12241 6.96356 3.23937 7.16472C3.35632 7.36588 3.4186 7.59414 3.42 7.82683V8.16683C3.42093 8.40178 3.35977 8.6328 3.2427 8.8365C3.12563 9.04021 2.95681 9.20936 2.75333 9.32683L2.65333 9.38683C2.34769 9.56386 2.12478 9.85494 2.03354 10.1962C1.9423 10.5374 1.99018 10.9009 2.16667 11.2068L2.31333 11.4602C2.49037 11.7658 2.78145 11.9887 3.12267 12.08C3.46389 12.1712 3.82738 12.1233 4.13333 11.9468L4.23333 11.8935C4.43603 11.7765 4.66595 11.7149 4.9 11.7149C5.13405 11.7149 5.36398 11.7765 5.56667 11.8935L5.85333 12.0602C6.05583 12.1771 6.22401 12.3452 6.34103 12.5476C6.45804 12.75 6.51976 12.9797 6.52 13.2135V13.3335C6.52 13.6871 6.66048 14.0263 6.91053 14.2763C7.16057 14.5264 7.49971 14.6668 7.85333 14.6668H8.14667C8.50029 14.6668 8.83943 14.5264 9.08948 14.2763C9.33953 14.0263 9.48 13.6871 9.48 13.3335V13.2135C9.48024 12.9797 9.54196 12.75 9.65898 12.5476C9.77599 12.3452 9.94418 12.1771 10.1467 12.0602L10.4333 11.8935C10.636 11.7765 10.866 11.7149 11.1 11.7149C11.3341 11.7149 11.564 11.7765 11.7667 11.8935L11.8667 11.9468C12.1726 12.1233 12.5361 12.1712 12.8773 12.08C13.2186 11.9887 13.5096 11.7658 13.6867 11.4602L13.8333 11.2002C14.0098 10.8942 14.0577 10.5307 13.9665 10.1895C13.8752 9.84827 13.6523 9.5572 13.3467 9.38016L13.2467 9.32683C13.0432 9.20936 12.8744 9.04021 12.7573 8.8365C12.6402 8.6328 12.5791 8.40178 12.58 8.16683V7.8335C12.5791 7.59855 12.6402 7.36753 12.7573 7.16382C12.8744 6.96012 13.0432 6.79097 13.2467 6.6735L13.3467 6.6135C13.6523 6.43646 13.8752 6.14539 13.9665 5.80416C14.0577 5.46294 14.0098 5.09945 13.8333 4.7935L13.6867 4.54016C13.5096 4.23452 13.2186 4.01161 12.8773 3.92037C12.5361 3.82913 12.1726 3.877 11.8667 4.0535L11.7667 4.10683C11.564 4.22385 11.3341 4.28546 11.1 4.28546C10.866 4.28546 10.636 4.22385 10.4333 4.10683L10.1467 3.94016C9.94418 3.82325 9.77599 3.65515 9.65898 3.45272C9.54196 3.25029 9.48024 3.02065 9.48 2.78683V2.66683C9.48 2.31321 9.33953 1.97407 9.08948 1.72402C8.83943 1.47397 8.50029 1.3335 8.14667 1.3335Z"
      {...stroke}
      strokeWidth="1.33333"
    />
    <path
      d="M8 10C9.10457 10 10 9.10457 10 8C10 6.89543 9.10457 6 8 6C6.89543 6 6 6.89543 6 8C6 9.10457 6.89543 10 8 10Z"
      {...stroke}
      strokeWidth="1.33333"
    />
  </SvgIcon>
);

/** White tick inside a checked checkbox. */
export const OptionCheckIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 9 9">
    <path
      d="M7.5 1.5L3 7L1.5 5.2"
      fill="none"
      stroke="#fff"
      strokeWidth="1.2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

/** Apply button tick. */
export const ApplyCheckIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M13.5 4.5L6 12L2.5 8.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.6"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

/** Funnel with X — Clear filter. */
export const ClearFilterIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M13.3581 1C14.8742 1 15.5546 2.86205 14.4674 3.84512L14.3576 3.93765L10.7144 6.7394C10.6796 6.76643 10.6514 6.80107 10.6321 6.84065C10.6127 6.88024 10.6026 6.92374 10.6026 6.96782V7.69837C10.6026 7.8773 10.5315 8.0489 10.405 8.17543C10.2785 8.30195 10.1069 8.37303 9.92797 8.37303C9.74904 8.37303 9.57744 8.30195 9.45092 8.17543C9.32439 8.0489 9.25331 7.8773 9.25331 7.69837V6.96782C9.25331 6.4599 9.48944 5.97896 9.89231 5.66959L13.5355 2.86687L13.5721 2.8341C13.6101 2.79269 13.6353 2.74108 13.6445 2.6856C13.6536 2.63011 13.6464 2.57315 13.6237 2.5217C13.601 2.47025 13.5638 2.42654 13.5166 2.39592C13.4694 2.3653 13.4144 2.3491 13.3581 2.34931H2.64072C2.58052 2.3495 2.52188 2.36847 2.47298 2.40359C2.42407 2.4387 2.38735 2.4882 2.36793 2.54518C2.34851 2.60217 2.34737 2.66379 2.36465 2.72146C2.38193 2.77913 2.41679 2.82996 2.46435 2.86687L6.10749 5.66959L6.25109 5.79295C6.40829 5.94577 6.53321 6.12858 6.61847 6.33055C6.70373 6.53252 6.74759 6.74955 6.74745 6.96878V12.7583C6.74745 12.8032 6.7579 12.8475 6.77797 12.8876C6.79805 12.9277 6.82719 12.9627 6.8631 12.9896L8.40518 14.1462L8.50541 14.2387C8.60841 14.355 8.66809 14.5033 8.67439 14.6586C8.68068 14.8138 8.63319 14.9665 8.53995 15.0908C8.44671 15.2151 8.31342 15.3034 8.16261 15.3407C8.0118 15.3781 7.85271 15.3623 7.71221 15.296L7.59559 15.2256L6.05352 14.0691C5.85014 13.9163 5.68506 13.7184 5.57132 13.4909C5.45757 13.2634 5.39829 13.0126 5.39814 12.7583V6.96782C5.39809 6.90104 5.37493 6.83634 5.3326 6.7847L5.28441 6.7394L1.64126 3.93765C0.402789 2.98349 1.07841 1 2.64168 1H13.3581Z"
      fill="currentColor"
    />
    <path
      d="M12.5836 9.38902C12.7101 9.26249 12.8817 9.19141 13.0607 9.19141C13.2396 9.19141 13.4112 9.26249 13.5377 9.38902C13.6643 9.51555 13.7354 9.68716 13.7354 9.8661C13.7354 10.045 13.6643 10.2166 13.5377 10.3432L12.3282 11.5527L13.5377 12.7623L13.6235 12.8683C13.7084 12.998 13.746 13.1529 13.73 13.3071C13.7141 13.4612 13.6456 13.6051 13.536 13.7147C13.4264 13.8243 13.2825 13.8928 13.1283 13.9087C12.9742 13.9247 12.8193 13.8871 12.6896 13.8022L12.5836 13.7165L11.374 12.5069L10.1645 13.7165L10.0584 13.8022C9.92879 13.8876 9.77365 13.9257 9.6192 13.91C9.46475 13.8943 9.32044 13.8258 9.21061 13.7161C9.10078 13.6063 9.03215 13.4621 9.01629 13.3077C9.00044 13.1532 9.03832 12.9981 9.12357 12.8683L9.21031 12.7623L10.4199 11.5527L9.21031 10.3432C9.08378 10.2166 9.0127 10.045 9.0127 9.8661C9.0127 9.68716 9.08378 9.51555 9.21031 9.38902C9.33684 9.26249 9.50845 9.19141 9.68739 9.19141C9.86633 9.19141 10.0379 9.26249 10.1645 9.38902L11.374 10.5986L12.5836 9.38902Z"
      fill="currentColor"
    />
  </SvgIcon>
);

/** Six-dot drag handle in Manage saved filters. */
export const DragDotsIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 12 12">
    <circle cx="4" cy="2.5" r="1" fill="currentColor" />
    <circle cx="8" cy="2.5" r="1" fill="currentColor" />
    <circle cx="4" cy="6" r="1" fill="currentColor" />
    <circle cx="8" cy="6" r="1" fill="currentColor" />
    <circle cx="4" cy="9.5" r="1" fill="currentColor" />
    <circle cx="8" cy="9.5" r="1" fill="currentColor" />
  </SvgIcon>
);

export const TrashIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 16 16">
    <path
      d="M2 4h12M6.5 4V2.5h3V4M3.5 4l.7 9.5h7.6l.7-9.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.3"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);
